import React from 'react';
import PropTypes from 'prop-types';
import { Form as FormikForm } from 'formik';
import TextField from '../../../../web-app-components/components/TextField';
import ButtonPrimary from '../../../../web-app-components/components/ButtonPrimary';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Paper from '@material-ui/core/Paper';

import LocationField from './components/LocationField';
import CategoriesSelectField from './components/CategoriesSelectField';
import FilesField from './components/FilesField';
import RegionSelectField from './components/RegionSelectField';
import DistrictSelectField from './components/DistrictSelectField';
import LanguageSelectField from './components/LanguageSelectField';
import QRCodeGenerator from './components/QRCodeGenerator';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > :not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
  translationSection: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '& > :not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
}));

const fieldIsEmpty = (values, key) => {
  const value = values?.[key]
  if (typeof value === 'string' || Array.isArray(value)) {
    return value.length === 0;
  }
  if(typeof value === 'object'){   
    return value === null
  }
  // For categories (single select), null means empty
  if (key === 'categories') {
    return value === null || value === undefined;
  }
  return typeof value !== 'number';
};


const Form = ({ isSubmitting, suggested, values, objectId }) => {
  const classes = useStyles();
  const getFieldLabel = (fieldName) => {
    const labels = {
      Title: 'Pavadinimas',
      Description: 'Aprašymas',
    };
    return labels[fieldName] ?? fieldName;
  };

  return (
    <FormikForm>
      <div className={classes.root}>
        {(!suggested || !fieldIsEmpty(values, 'Coordinates')) && <LocationField name="Coordinates" />}
        
        {/* Language Selector and Translation Fields */}
        <Paper className={classes.translationSection} elevation={1}>
          <LanguageSelectField
            name="locale"
            label="Kalba / Language"
            fullWidth
          />
          {(!suggested || !fieldIsEmpty(values, 'Title')) && (
            <TextField 
              name="Title" 
              label={getFieldLabel('Title')} 
              fullWidth 
            />
          )}
          {(!suggested || !fieldIsEmpty(values, 'Description')) && (
            <TextField
              name="Description"
              label={getFieldLabel('Description')}
              multiline
              rows={4}
              fullWidth
            />
          )}
        </Paper>
        {(!suggested || !fieldIsEmpty(values, 'Pictures')) && <FilesField
          name="Pictures"
          accept="image/*"
          label="Nuotraukos"
          disabled={isSubmitting}
        />}
        {(!suggested || !fieldIsEmpty(values, 'AudioRecordings')) && <FilesField
          name="AudioRecordings"
          accept="audio/*"
          label="Garso įrašai"
          disabled={isSubmitting}
        />}
        {(!suggested || !fieldIsEmpty(values, 'categories')) && <CategoriesSelectField
          name="categories"
          label="Kategorijos"
          fullWidth
        />}
        {(!suggested || !fieldIsEmpty(values, 'Region')) && <RegionSelectField
          name="Region"
          label="Regionas"
          fullWidth
        />}
        {(!suggested || !fieldIsEmpty(values, 'District')) && <DistrictSelectField
          name="District"
          label="Savivaldybė"
          fullWidth
        />}
        {(!suggested || !fieldIsEmpty(values, 'GoldCoinAmount')) && <TextField 
          name="GoldCoinAmount" 
          label="Auksinukų skaičius" 
          type="number"
          fullWidth 
        />}
        {(!suggested || !fieldIsEmpty(values, 'VideoURL')) && <TextField name="VideoURL" label="Video nuoroda" fullWidth />}
        {(!suggested || !fieldIsEmpty(values, 'WebsiteURL')) && <TextField name="WebsiteURL" label="Internetinė svetainė" fullWidth />}
        {(!suggested || !fieldIsEmpty(values, 'BookingURL')) && <TextField name="BookingURL" label="Booking nuoroda" fullWidth />}
        {(!suggested || !fieldIsEmpty(values, 'PhoneNumber_1')) && <TextField name="PhoneNumber_1" label="Telefono numeris (1)" fullWidth />}
        {(!suggested || !fieldIsEmpty(values, 'PhoneNumber_2')) && <TextField name="PhoneNumber_2" label="Telefono numeris (2)" fullWidth />}
        {objectId && (
          <QRCodeGenerator 
            objectId={objectId}
            goldCoinAmount={values.GoldCoinAmount}
            disabled={isSubmitting}
          />
        )}
        <ButtonPrimary type="submit" disabled={isSubmitting}>
          {suggested ? 'Patvirtinti' : 'Išsaugoti'}
        </ButtonPrimary>
      </div>
    </FormikForm>
  );
};

Form.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  suggested: PropTypes.bool,
  values: PropTypes.object,
  objectId: PropTypes.string,
};

export default Form;
